import { DataTable } from "@/components/ui/data-table";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Trash2, Settings } from "lucide-react";
import { useState } from "react";
import { AccessControlDialog } from "./AccessControlDialog";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UserListProps {
  users: any[];
  isLoading: boolean;
  onUserDeleted: () => void;
}

export const UserList = ({ users, isLoading, onUserDeleted }: UserListProps) => {
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const handleDeleteUser = async (userId: string) => {
    try {
      console.log("Deleting user:", userId);
      const { error } = await supabase
        .from('owner_users')
        .delete()
        .eq('user_id', userId);

      if (error) {
        console.error('Error deleting user:', error);
        throw error;
      }
      
      toast.success("Utilisateur supprimé avec succès");
      onUserDeleted();
    } catch (error) {
      console.error('Error deleting user:', error);
      toast.error("Erreur lors de la suppression de l'utilisateur");
    }
  };

  const columns = [
    {
      id: "user",
      label: "Utilisateur",
      cell: (row: any) => (
        <div className="flex items-center gap-3">
          <Avatar>
            <AvatarImage src={row.profiles?.avatar_url} />
            <AvatarFallback>{row.profiles?.full_name?.[0] || 'U'}</AvatarFallback>
          </Avatar>
          <div>
            <div className="font-medium">{row.profiles?.full_name || 'Sans nom'}</div>
            <div className="text-sm text-muted-foreground">{row.user_id}</div>
          </div>
        </div>
      ),
    },
    {
      id: "hidden_features",
      label: "Fonctionnalités masquées",
      cell: (row: any) => (
        <div className="flex gap-2 flex-wrap">
          {(row.hidden_features || []).map((feature: string) => (
            <Badge key={feature} variant="secondary">
              {feature}
            </Badge>
          ))}
        </div>
      ),
    },
    {
      id: "actions",
      label: "Actions",
      cell: (row: any) => (
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSelectedUserId(row.user_id)}
          >
            <Settings className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => handleDeleteUser(row.user_id)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={users}
      />
      <AccessControlDialog
        isOpen={!!selectedUserId}
        onClose={() => setSelectedUserId(null)}
        userId={selectedUserId || ''}
      />
    </>
  );
};